import React from 'react';

type State = {
  isVisible: boolean;
};
type Action = { type: 'SHOW' | 'HIDE' };
type Dispatch = (action: Action) => void;

const AuthContext = React.createContext<State>(undefined!);
const AuthDispatchContext = React.createContext<Dispatch>(undefined!);

function userReducer(state: State, action: Action) {
  switch (action.type) {
    case 'SHOW':
      return { isVisible: true };

    case 'HIDE':
      return { isVisible: false };

    default:
      return state;
  }
}

function AuthProvider({ children }: { children: React.ReactNode }) {
  const initialState = {
    isVisible: false,
  };

  const [state, dispatch] = React.useReducer(
    (prevState: State, action: Action) => userReducer(prevState, action),
    initialState
  );

  return (
    <AuthContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>{children}</AuthDispatchContext.Provider>
    </AuthContext.Provider>
  );
}

const useAuthState = () => React.useContext(AuthContext);
const useAuthDispatch = () => React.useContext(AuthDispatchContext);

export { AuthProvider, useAuthDispatch, useAuthState };
